<p [innerHTML]="emailContent | safe: 'html'"></p>
